// extracted by mini-css-extract-plugin
export var avatarContainer = "_3o-1";
export var largeAvatarContainer = "_3o-2";
export var smallAvatarContainer = "_3o-0";